import logo2 from './logo.png';
import unibenlogo from './uniben-logo.png';
import { Link } from 'react-router-dom';
import AdvertCard from './AdvertCard';
import black_students from './black_students.jpg';
import EditorInfo from './EditorInfo';
import './LandingPage.css';  // shared look: header, footer, buttons, tokens
import './Manuscript.css';   // extra rules for this page only

function Manuscript() {
  return (
    <div className="jt-page">
      <a className="jt-skip" href="#main">Skip to content</a>

      {/* Header */}
      <header className="jt-header">
        <div className="jt-header__inner">
          <div className="jt-brand">
            <div className="jt-brand__logos">
              <img src={logo2} alt="JTVET logo" />
              <img src={unibenlogo} alt="University of Benin logo" />
            </div>
            <div>
              <p className="jt-brand__name">JTVET</p>
              <p className="jt-brand__sub">Nigerian Research Journal</p>
            </div>
          </div>

          <nav className="jt-nav" aria-label="Primary">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/published">Published manuscripts</Link></li>
              
            </ul>
          </nav>
        </div>
      </header>

      <main id="main">
        {/* Hero */}
        <section className="jt-hero">
          <div className="jt-hero__inner">
            <div className="jt-hero__text">
              <h1>Submit your manuscript to JTVET</h1>
              <p className="jt-hero__lead">
                Read the author guidelines, prepare your paper in Microsoft
                Word, then submit it online.
              </p>
              <div className="jt-hero__actions">
                <h2>Submit your article to:</h2>
                <div className="jt-hero__text">
              <h2>jtvetuniben.fcet@gmail.com</h2>
              </div>
                <p> </p>
                <a
                  href="/AUTHOR’S GUIDELINES _TEMPLATE.pdf"
                  download
                  className="jt-btn jt-btn--ghost"
                >
                  Download author guidelines
                </a>
              </div>
            </div>

            <div className="jt-hero__ad">
              <AdvertCard
                title="Advertisement board"
                image={black_students}
                description="Your advert will go here!"
                link="#"
              />
            </div>
          </div>
        </section>

        {/* Guidelines + help */}
        <section className="jt-section jt-body">
          <article className="jt-article">
            <h2>Manuscript submission guidelines</h2>
            <p>
              Before you submit, make sure your manuscript follows the{' '}
              <a href="/AUTHOR’S GUIDELINES _TEMPLATE.pdf" download>
                author guidelines
              </a>
              . Then submit it through the <Link to="/login">online submission page</Link>.
            </p>

            <h3 className="jt-sub">What we require</h3>
            <ul className="jt-scope jt-requirements">
              <li>
                The work is original. It has not been published and is not under
                review by another journal.
              </li>
              <li>
                It adds new knowledge or insight to technical and vocational
                education and training.
              </li>
              <li>
                It is written in English and submitted in Microsoft Word format.
              </li>
              <li>
                Email addresses for all authors are included, along with the
                telephone number of the corresponding author.
              </li>
              <li>
                You confirm at submission that the work has not been published
                before and is not being reviewed elsewhere.
              </li>
            </ul>

           
          </article>

          <aside className="jt-aside">
            <h2>Need help?</h2>
            <p className="jt-aside__text">
              If you have trouble submitting, contact the{' '}
              <Link to="/editorinfo">editorial office</Link>.
            </p>

            <h2>Submission issues</h2>
            <p className="jt-aside__text">
              Address all manuscript submission issues to:
            </p>
            <EditorInfo />
          </aside>
        </section>
      </main>

      {/* Footer */}
      <footer className="jt-footer">
        <div className="jt-footer__inner">
          <p>
            Copyright © 2026 Journal of Technical and Vocational Education and
            Training. All rights reserved.
          </p>
          <p>
            Designed and developed by <a href="#">ISITEC</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Manuscript;
